export enum CycleStatus {
  Draft = 'draft',
  Selection = 'selection',
  TestingAndSelection = 'testingAndSelection',
  Testing = 'testing',
  Completed = 'completed',
  MissedDeadline = 'missedDeadline',
}
